import React from 'react';

import './SlideSettingsModal.scss';
import Tab from '../SettingsTab/Tab';
import TabContent from '../SettingsTab/TabContent';
import reducerStore from '../../reducers/reducerStore';
import axios from '../../lib/AxiosInstance';

class SlideSettingsModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            panels: [
                {
                    header: 'Slide inställningar',
                    renderClass: 'SlideSettingsModal',
                },
            ],
            activePanel: 0,

            slide: props.editId ? props.slide : {
                title: null,
                backgroundImage: null,
                headerType: null,
                headerValue: null,
                position: null,
                showCompanyLogo: null,
                competitionActive: null,
                widgets: [],
                competitionSettings: {
                    pointsGoal: 0,
                    dateFrom: null,
                    dateTo: null,
                    selectedPoints: [],
                    _selectedPoints: [],
                },
            },
        };

        this.setToActive = this.setToActive.bind(this);
        this.deleteSlide = this.deleteSlide.bind(this);
        this.saveSlide = this.saveSlide.bind(this);
    }

    setToActive() {
        const { editId, stopEditing } = this.props;
        const { slide } = this.state;

        const inactiveSlide = Object.assign({}, slide, { tvIndex: 1 });

        axios.put(`/api/salestv/${editId}`, inactiveSlide).then(() => {
            reducerStore.dispatch({ type: 'SLIDE SAVED', slide: inactiveSlide });

            stopEditing();
        }).catch(error => console.log(error));
    }

    deleteSlide() {
        // TODO: Make a modal where you have to confirm that you would like to delete the slide.
        const { editId, stopEditing } = this.props;

        axios.delete(`/api/salestv/${editId}`).then(() => {
            reducerStore.dispatch({ type: 'REMOVE SLIDE', id: editId });

            stopEditing();
        }).catch(error => console.log(error));
    }

    saveSlide() {
        const { editId, stopEditing } = this.props;
        const { slide } = this.state;

        if (editId) {
            return axios.put(`/api/salestv/${editId}`, slide).then(() => {
                reducerStore.dispatch({ type: 'SLIDE SAVED', slide });

                stopEditing();
            }).catch(error => console.log(error));
        }

        slide.tvIndex = this.props.tvIndex;

        return axios.post('/api/salestv', slide).then((newSlide) => {
            reducerStore.dispatch({ type: 'ADD SLIDE', data: newSlide.data });

            stopEditing();
        }).catch(error => console.log(error));
    }

    render() {
        const { editId, slides } = this.props;
        const { slide, panels, activePanel } = this.state;

        const tabs = panels.map((panel, index) => (
            <Tab
                header={panel.header}
                active={index === activePanel}
                changeTab={this.changeTab}
                key={index}
                index={index}
            />
        ));

        const tabContent = panels.map((panel, index) => (
            <TabContent
                {...this.props}
                deleteSlide={this.deleteSlide}
                renderClass={panel.renderClass}
                slide={slide}
                active={index === activePanel}
                saveSlide={this.saveSlide}
                key={index}
            />
        ));

        const onlyActiveSlides = slides.filter(elem => elem.inactive !== 1);
        const onlyOneActiveSlide = onlyActiveSlides.length === 1;

        return (
            <div className="container slide-settings-holder">
                <div className="overlay" onClick={this.props.stopEditing}>
                    <div className="close-modal-btn">
                        <i className="fa fa-times" aria-hidden="true" />
                    </div>
                </div>
                <div className="modal edit-widget slidesettings">
                    <div className="settings-header">
                        <h2>{this.state.panels[0].header}</h2>
                    </div>

                    <div className="modal-content">
                        {tabContent}
                    </div>
                </div>
            </div>
        );
    }
}

SlideSettingsModal.propTypes = {
    editId: React.PropTypes.string,
    currentSlideId: React.PropTypes.string,
    stopEditing: React.PropTypes.func,
    slide: React.PropTypes.object,
    slides: React.PropTypes.array,
    tvIndex: React.PropTypes.number,
};

export default SlideSettingsModal;



/** WEBPACK FOOTER **
 ** ./client/components/SlideSettingsModal/SlideSettingsModal.jsx
 **/